export const getInflucencersCompleteness = {
  percentage: 60,
  registration: {
    detail: {
      country: true,
      zipcode: true,
      address: true,
      city: true,
      uf: true,
      addressNumber: true,
      neighborhood: true,
      name: true,
      email: true,
      nationality: true,
      documentType: true,
      document: true,
      birthday: true,
      race: true,
      gender: true,
      phone: true,
      phoneValid: true,
    },
    percentage: 100,
  },
  socialNetwork: {
    percentage: 100,
    detail: {
      socialNetwork: true,
    },
  },
  paymentData: {
    percentage: 100,
    detail: {
      bankCode: true,
      bankAccountAgency: true,
      bankAccountNumber: true,
      bankAccountDigit: true,
      holderName: true,
      holderDocument: true,
      nationalDocument: true,
      recordEmployment: true,
    },
  },
  mediakitCount: {
    percentage: 0,
    detail: [
      {
        percentage: 0,
        profileId: '17841401647609427',
        detail: {
          communication: false,
          frontCover: false,
          purpose: false,
          whoDoes: false,
        },
      },
      {
        percentage: 0,
        profileId: '17841444195646913',
        detail: {
          communication: false,
          frontCover: false,
          purpose: false,
          whoDoes: false,
        },
      },
      {
        percentage: 0,
        profileId: '17841457949721362',
        detail: {
          communication: false,
          frontCover: false,
          purpose: false,
          whoDoes: false,
        },
      },
    ],
  },
  progressive: {
    percentage: 0,
    detail: {
      '59db5a10-b15c-4922-8b7e-ad8b0f99ce40': {
        '07f35611-e4ee-47e9-98c2-bf05b5008046': false,
        '17ba747f-fa51-4c65-8668-fda4e90b2ada': false,
        '2881c1a5-d3ce-445c-9fbf-2180c806a902': false,
        '58cd48a4-3f78-4502-9f0a-2db7844e50c2': false,
        'b92dee91-f008-477e-9466-a4bcc0c3f3b6': false,
        'd12803a8-42fc-413c-861f-e2221b707160': false,
        'fd847b11-2ddd-45f8-a77e-50f8301aaa7a': false,
      },
      'a840940a-c2d9-4222-876d-59c588e5299e': {
        '39225861-2da2-448b-a8cb-5199b1de58f6': false,
        '4c5888e8-3bbc-440e-850d-b0aabb272f40': false,
        '4eb10e51-ff33-4700-8ce3-e0c4e49fd5fd': false,
        '82f4aefc-fd79-44ca-9127-848276599639': false,
        '8f8b591d-b585-47c4-89da-ffb49f85ea82': false,
        '9361890a-ab5d-4c8e-84a7-bc67a8c8b0e8': false,
        'cbf4fe5a-335f-4b9d-a695-173cb999c8b2': false,
        'f1888d80-c30d-4fd4-a0cd-fe25a877025a': false,
      },
    },
  },
}

export const getCategoriesBySocialNetwork = [
  {
    id: 252,
    profileId: '17841457949721362',
    socialNetwork: 'instagram',
    updatedAt: '2023-07-18T13:00:11.000Z',
    description: 'APPs',
    description_en: 'APPs',
    description_es: 'APPs',
    parentId: null,
    childs: [],
  },
]

export const putProfileCategories = [
  {
    id: 252,
    profileId: '17841401647609427',
    socialNetwork: 'instagram',
    updatedAt: '2023-08-25T23:18:02.000Z',
    description: 'APPs',
    description_en: 'APPs',
    description_es: 'APPs',
    parentId: null,
    childs: [],
  },
  {
    id: 51,
    profileId: '17841401647609427',
    socialNetwork: 'instagram',
    updatedAt: '2023-08-25T23:18:02.000Z',
    description: 'Ativismo e Causas Sociais',
    description_en: 'Activism & Social Causes',
    description_es: 'Activismo y causas sociales',
    parentId: null,
    childs: [],
  },
  {
    id: 38,
    profileId: '17841401647609427',
    socialNetwork: 'instagram',
    updatedAt: '2023-08-25T23:18:02.000Z',
    description: 'Lifestyle',
    description_en: 'Lifestyle',
    description_es: 'Estilo de vida',
    parentId: null,
    childs: [],
  },
]

export const putProfileCategoriesInstagramMock = [
  {
    id: 4,
    profileId: '17841401647609427',
    socialNetwork: 'instagram',
    updatedAt: '2022-12-29T00:16:44.000Z',
    description: 'Automotivo',
    description_en: 'Automotive',
    description_es: 'Automotor',
    parentId: null,
    childs: [
      {
        id: 172,
        profileId: '17841401647609427',
        socialNetwork: 'instagram',
        updatedAt: '2022-12-29T00:16:44.000Z',
        description: 'Barcos',
        description_en: 'Boats',
        description_es: 'Barcos',
        parentId: 4,
      },
    ],
  },
]

export const putProfileCategoriesTiktokMock = [
  {
    id: 4,
    profileId: '56753893381',
    socialNetwork: 'tiktok',
    updatedAt: '2022-12-29T00:16:44.000Z',
    description: 'Automotivo',
    description_en: 'Automotive',
    description_es: 'Automotor',
    parentId: null,
    childs: [
      {
        id: 172,
        profileId: '56753893381',
        socialNetwork: 'tiktok',
        updatedAt: '2022-12-29T00:16:44.000Z',
        description: 'Barcos',
        description_en: 'Boats',
        description_es: 'Barcos',
        parentId: 4,
      },
    ],
  },
]

export const putProfileCategoriesYoutubeMock = [
  {
    id: 4,
    profileId: '56753893381',
    socialNetwork: 'youtube',
    updatedAt: '2022-12-29T00:16:44.000Z',
    description: 'Automotivo',
    description_en: 'Automotive',
    description_es: 'Automotor',
    parentId: null,
    childs: [
      {
        id: 172,
        profileId: '56753893381',
        socialNetwork: 'youtube',
        updatedAt: '2022-12-29T00:16:44.000Z',
        description: 'Barcos',
        description_en: 'Boats',
        description_es: 'Barcos',
        parentId: 4,
      },
    ],
  },
]

export const putProfileCategoriesTwitterMock = [
  {
    id: 4,
    profileId: '56753893381',
    socialNetwork: 'twitter',
    updatedAt: '2022-12-29T00:16:44.000Z',
    description: 'Automotivo',
    description_en: 'Automotive',
    description_es: 'Automotor',
    parentId: null,
    childs: [
      {
        id: 172,
        profileId: '56753893381',
        socialNetwork: 'twitter',
        updatedAt: '2022-12-29T00:16:44.000Z',
        description: 'Barcos',
        description_en: 'Boats',
        description_es: 'Barcos',
        parentId: 4,
      },
    ],
  },
]

export const getProfileWhiteLabel = {
  profileId: '051f63162c7a',
  landingPagesInfos: [
    {
      _id: '5f28435e11cfbb0011d97653',
      name: 'Consultora Natura',
      domains: ['consultoranatura.squidit.com.br'],
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/5f28435e11cfbb0011d97653/webapp-favicon',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/5f28435e11cfbb0011d97653/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/5f28435e11cfbb0011d97653/webapp-negativeLogo',
        },
        backgroundDesktop: {
          url: '',
        },
        backgroundMobile: {
          url: '',
        },
      },
      blockingInformation: {
        isBlocked: true,
        reason: 'teste do guedes',
        responsibleFullName: 'Guilherme Guedes',
        dateOfBlocked: '2022-12-05T18:05:07.000Z',
      },
    },
    {
      _id: '611ac8b14de7c20011502084',
      domains: ['consultorasnaturachile.squidit.com.br', 'consultora.natura.cl', 'stg-consultorasnaturachile.squidit.com.br'],
      name: 'Consultoras Natura Chile',
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/611ac8b14de7c20011502084/webapp-favicon',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/611ac8b14de7c20011502084/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/611ac8b14de7c20011502084/webapp-negativeLogo',
        },
        backgroundDesktop: {
          url: '',
        },
        backgroundMobile: {
          url: '',
        },
      },
      blockingInformation: {
        isBlocked: false,
      },
    },
    {
      _id: '622f466a3276d7001213e9d0',
      domains: ['time.squidit.com.br'],
      name: 'Time Squid',
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/622f466a3276d7001213e9d0/webapp-favicon',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/622f466a3276d7001213e9d0/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/622f466a3276d7001213e9d0/webapp-negativeLogo',
        },
        backgroundDesktop: {
          url: '',
        },
        backgroundMobile: {
          url: '',
        },
      },
      blockingInformation: {
        isBlocked: true,
        reason: 'O usuário solicitou o descadastramento em 20/10/2022',
        responsibleFullName: 'Wanderson Sales Pereira',
        dateOfBlocked: '2022-10-20T18:10:08.000Z',
      },
    },
    {
      _id: '62e3ef2bb9a054291dcc5697',
      domains: ['grupoboticario.squidit.com.br', 'boticario.squidit.com.br', 'revendedoresoboticario.squidit.com.br'],
      name: 'Influenciadores da Beleza',
      images: {
        favicon: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-negativeLogo',
        },
        logo: {
          url: 'https://storage.googleapis.com/squid-dev/62e3ef2bb9a054291dcc5697/webapp-logo',
        },
        negativeLogo: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-logo',
        },
        backgroundDesktop: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-backgroundDesktop',
        },
        backgroundMobile: {
          url: 'https://storage.googleapis.com/squid-landing-pages/62e3ef2bb9a054291dcc5697/webapp-backgroundMobile',
        },
      },
      blockingInformation: {
        isBlocked: false,
      },
    },
    {
      _id: '',
      name: 'Squid',
      domains: ['app.squidit.com.br'],
      images: {
        favicon: {
          url: '',
        },
        logo: {
          url: '',
        },
      },
      blockingInformation: {
        isBlocked: false,
      },
    },
  ],
}
